import { AppBar, IconButton, Toolbar } from "@mui/material"
import { HambergerMenu } from "iconsax-react"
import Link from "next/link"
import React, { useState } from "react"
import MobileDrawer from "../drawer"
import BasicLogo from "../../../../common/BasicLogo"

const MobileAppBar = ({ isOtherPage = false }) => {
  const [open, setOpen] = useState(false)

  const toggleDrawer = event => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return
    }

    setOpen(false)
  }

  return (
    <>
      <MobileDrawer open={open} toggleDrawer={toggleDrawer} />
      <header>
        <AppBar
          sx={{
            position: "sticky",
            top: 0,
            borderRadius: "0 0 25px 25px",
            color: "#fff",
            background: "transparent"
          }}
          elevation={0}
        >
          <Toolbar sx={{ py: 1.5, justifyContent: "space-between", alignItems: "center" }}>
            {/* Logo */}
            <Link href='/'>
              <BasicLogo />
            </Link>

            <IconButton color={isOtherPage ? "" : "inherit"} onClick={() => setOpen(true)}>
              <HambergerMenu />
            </IconButton>
          </Toolbar>
        </AppBar>
      </header>
    </>
  )
}

export default MobileAppBar
